module.exports = __webpack_public_path__ + "img/play--green.aa8c4dae.svg";